import { render } from "./LiveTchatView.vue?vue&type=template&id=59e066db&scoped=true&ts=true"
import script from "./LiveTchatView.vue?vue&type=script&lang=ts"
export * from "./LiveTchatView.vue?vue&type=script&lang=ts"

import "./LiveTchatView.vue?vue&type=style&index=0&id=59e066db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e066db"]])

export default __exports__